import { render, staticRenderFns } from "./WorkflowOpen.vue?vue&type=template&id=49d3980f&scoped=true&"
import script from "./WorkflowOpen.vue?vue&type=script&lang=ts&"
export * from "./WorkflowOpen.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowOpen.vue?vue&type=style&index=0&id=49d3980f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3980f",
  null
  
)

export default component.exports